import BUY_IT_AGAIN_BAG_PAGE_CONSTANTS from './BuyItAgainBagPage.constants';

export const openShopAllDrawer = (payload) => ({
  type: BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.OPEN_SHOP_ALL_BIA_DRAWER,
  payload,
});

export const getBuyItAgainBagPageProducts = () => ({
  type: BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.BUY_IT_AGAIN_BAG_PAGE_FETCH_PRODUCTS,
});

export const fetchBiaBagPageDrawerProducts = () => ({
  type: BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.FETCH_BIA_BAGPAGE_DRAWER_PRODUCTS,
});

export const getMoreBiaBagPageDrawerProducts = () => ({
  type: BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.GET_MORE_BIA_BAGPAGE_DRAWER_PRODUCTS,
});

export const setBIAAvailableProduct = (payload) => ({
  type: BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.SET_BIA_PRODUCTS_AVAILABLE_PRODUCTS,
  payload
});
